import Router from 'lib/Router';

import ImageForm from 'view/image/form';

import Image from 'model/Image';
import { loadPondPage } from 'db/persist';

export default Router.extend({
	routes: {
		'image/create/:id': 'executeCreate',
	},

	// création d'une image (id=pond)
	executeCreate: function( id )
	{
		loadPondPage( id ).then( function( pond )
		{
			if( !pond )
			{
				return console.error404();
			}

			var user = app.getStore('user');

			var image = new Image;
			image.setPond( pond );
			image.setUser( user );

			var view = new ImageForm({
				model: image
			});

			app.render( view );
		} ).catch( function()
		{
			console.error404();
		} );
	}


});
